export interface LoggingService {
  logDebug(message: string, properties?: { [key: string]: unknown }): void;
  logInfo(message: string, properties?: { [key: string]: unknown }): void;
  logWarning(message: string, properties?: { [key: string]: unknown }): void;
  logError(exception: Error, properties?: { [key: string]: unknown }): void;
  logApiError(properties?: { [key: string]: unknown }, stack?: string): void;
}
